<template>
  <section
    :aria-label="post.title"
    class="a-cover header-padding flex flex-col lg:flex-row"
  >
    <div
      class="relative w-full flex-c h-full px-3vw md:px-15vw bg-black-50"
      @click.self="handleClose"
    >
      <div class="bg-primary-95 max-h-md overflow-y-auto w-160">
        <component
          :is="component"
          :post="post"
          :is-spot="true"
          :titles="false"
          class="w-full h-full"
        />
      </div>

      <BtnBack
        icon="CloseIcon"
        aria="Back"
        :iconsize="mobile ? '32px' : '35px'"
        iconcolor="white"
        class="bg-primary rounded-full absolute top-4 right-3vw md:right-4"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { capitalize } from '@/mixins'

import Article from '@/components/Article.vue'
import Gallery from '@/components/Gallery.vue'
import Video from '@/components/Video.vue'
import BtnBack from '@/components/buttons/BtnBack.vue'

export default {
  name: 'Media',

  components: {
    Article,
    Gallery,
    Video,
    BtnBack
  },

  mixins: [capitalize],

  props: {
    location: {
      type: Object,
      default: () => {}
    },
    palette: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(['mobile']),
    ...mapGetters(['post']),

    component() {
      return this.capitalize(this.post.type)
    }
  },

  mounted() {
    document.addEventListener('keyup', this.handleEscape)
  },

  beforeDestroy() {
    document.removeEventListener('keyup', this.handleEscape)
  },

  methods: {
    handleClose() {
      this.$router.push({ name: this.$route.meta.back })
    },

    handleEscape(e) {
      if (e.key === 'Escape') {
        this.$router.push({ name: this.$route.meta.back })
      }
    }
  }
}
</script>
